import * as firebaseActions from './Firebase/firebaseActions'
import * as GoogleMapActions from './GoogleMaps/googleMapsActions'
import * as GoogleAnalyticsActions from "./GoogleAnalytics/googleAnalyticsActions"


export const ActionCreators = Object.assign({},
    firebaseActions,
    GoogleMapActions,
    GoogleAnalyticsActions
);




// WEBPACK FOOTER //
// ./src/actions/index.js